export default __webpack_public_path__ + "static/media/residence.0bbfb12a.svg";